import React, { useEffect, useState } from 'react'
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Link } from 'react-router-dom';
import { useRecoilState, useRecoilValue } from 'recoil';
import { isTeacherId } from '../../database/isTeacherId';
import { TextField } from '@mui/material';
import { teacherIdState } from '../../globalStates/general/teacherId';
import { userDataState } from '../../globalStates/general/userData';
import { gameStatusState } from '../../globalStates/general/gameStatus';
import ItemSelectArea from './MyPage/ItemSelectArea';
import { levelState } from '../../globalStates/general/level';
import { useMedia } from 'use-media';



const TeacherMyPage = () => {
  const [gameStatusValue, setGameStatusValue] = useRecoilState(gameStatusState);
  const [unSuccessful, setUnSuccessful] = useState(false);
  const [idCertification, setIdCertification] = useState(false);
  const [createIdDisplay, setCreateIdDisplay] = useState("none");
  const [createIdState, setCreateIdState] = useState("");
  const [createStatus, setCreateStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const [teacherId, setTeacherId] = useRecoilState(teacherIdState);
  const [level, setLevel] = useRecoilState(levelState);
  const isPC = useMedia({ minWidth: '1000px' });
  const [fase, setFase] = useState(0); // スマートフォンの場合のみ使用　0: レベル選択 1: アイテム選択


  useEffect(() => {
    if (fase === 0 && level) {
      setFase(1);
    }
  }, [level]);

  const inputPass = (e) => {
    isTeacherId(e.value).then((status) => {
      if (status) {
        setUnSuccessful(false);
        setIdCertification(true);
        setTeacherId(e.value);
      } else {
        setUnSuccessful(true);
        setIdCertification(false);
      }
    });
  }
  let teacherPageStyle;
  if (isPC) {
    teacherPageStyle = css`

    width: 100vw;
    height: 100vh;
    .window {
      position: relative;
      h3 {
        position: absolute;
        top: 80px;
        left: 50%;
        transform: translateX(-50%);
      }
      p {
        position: absolute;
        top: 300px;
        left: 50%;
        transform: translateX(-50%);
        white-space: nowrap;
        font-size: 0.7em;
      }
      button {
        cursor: pointer;
        position: absolute;
        border-radius: 2px;
        border: none;
        border-bottom: 0.5px solid #555;
        top: 430px;
        left: 50%;
        transform: translateX(-50%);
        white-space: nowrap;
        font-size: 0.7em;
      }
      color: #555;

      border-radius: 15px;
      margin: 150px auto;
      text-align: center;
      width: 500px;
      height: 500px;
      background-color: #e6e6e6b8;
      box-shadow:
        0 1.9px 2.5px rgba(0, 0, 0, 0.057),
        0 5px 6.1px rgba(0, 0, 0, 0.076),
        0 10.1px 11.4px rgba(0, 0, 0, 0.086),
        0 19.2px 19.8px rgba(0, 0, 0, 0.092),
        0 38.4px 34.8px rgba(0, 0, 0, 0.1),
        0 101px 74px rgba(0, 0, 0, 0.13);
    }
  `;
  } else {
    teacherPageStyle = css`
      .fase-change {
        display: ${fase === 0 ? "none" : "block"};
        position: absolute;
        width: 100px;
        height: 50px;
      }
      .start-btn {
      display: ${fase === 0 ? "none" : "block"};
      position: absolute;
      bottom: 50px;
      right: 50px;
      background-color: white;
      color: #555555;
      width: 120px;
      height: 60px;
      border-radius: 10px;
      font-size: 1.2em;
      cursor: pointer;
      transition: .3s;
      &:hover {
        background-color: #555555;
        color: white;
      }

    }
    width: 100vw;
    height: 100vh;
    .window {
      margin: 10% auto;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;

      h3 {
        position: absolute;
        top: 10px;
        left: 50%;
        transform: translateX(-50%);
      }
      p {
        position: absolute;
        top: 65vh;
        left: 50%;
        transform: translateX(-50%);
        white-space: nowrap;
        font-size: 0.7em;
      }
      button {
        cursor: pointer;
        position: absolute;
        border-radius: 2px;
        border: none;
        border-bottom: 0.5px solid #555;
        top: 430px;
        left: 50%;
        transform: translateX(-50%);
        white-space: nowrap;
        font-size: 0.7em;
      }
      color: #555;

      border-radius: 15px;

      text-align: center;
      width: 65vw;
      height: 55vh;
      background-color: #e6e6e6b8;
      box-shadow:
        0 1.9px 2.5px rgba(0, 0, 0, 0.057),
        0 5px 6.1px rgba(0, 0, 0, 0.076),
        0 10.1px 11.4px rgba(0, 0, 0, 0.086),
        0 19.2px 19.8px rgba(0, 0, 0, 0.092),
        0 38.4px 34.8px rgba(0, 0, 0, 0.1),
        0 101px 74px rgba(0, 0, 0, 0.13);
    }
  `;
  }
  const createIdWindowStyle = css`
    text-align: center;
    display: ${createIdDisplay};
    p.message {
      margin-top: 100px;
      font-size: 0.8em;
    }
    div.create-status {
      font-size: 0.8em;
      color: ${createStatus ? "green" : "red"};
    }
    h3 {
      text-align: center;
      margin-top: 90px;
      }
    color: #555;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -58.5%);
    border-radius: 15px;
    background-color: #e7e7e7;
    animation: bigger 1s ease forwards;
    z-index: 10;
    button {
      text-align: center;
    }
    @keyframes bigger {
      0% {
        width: 0;
        height: 0;
        opacity: 0;
      }
      100% {
        width: 600px;
        height: 600px;
        opacity: 1;
      }
    }
  `;

  const userData = useRecoilValue(userDataState);
  let levelSelectArea;
  let myPageStyle;
  let message;
  let levelList;
  if (isPC) {
    levelSelectArea = css`
    display: flex;
    margin-right: 50px;
    margin-left: 150px;
    align-items: center;
    text-align: center;
    padding: 0;
    /* margin: 0; */
    h3 {
      font-size: 1.7em;
      color: #555555;
    }
    rt {
      text-align: center;
    }
  `;
    myPageStyle = css`
    .fase-change {
      display: none;
    }
    height: 80vh;
    .start-btn {
      position: absolute;
      bottom: 50px;
      right: 200px;
      background-color: white;
      color: #555555;
      width: 100px;
      height: 100px;
      border-radius: 100%;
      font-size: 1.2em;
      cursor: pointer;
      transition: .3s;
      &:hover {
        background-color: #555555;
        color: white;
      }

    }
  `;
    message = css`
    margin: 70px 0;
    text-align: center;

  `;

    levelList = css`
    width: 30vw;
    padding: 0;
    /*== ボタン共通設定 */
    button{
        /*アニメーションの起点とするためrelativeを指定*/
        position: relative;
        overflow: hidden;
        /*ボタンの形状*/
        text-decoration: none;
        display: inline-block;
        border: 2px solid #555;/* ボーダーの色と太さ */
        padding: 10px 30px;
        text-align: center;
        outline: none;
        /*アニメーションの指定*/
        transition: ease .2s;
    }

    /*ボタン内spanの形状*/
    button span {
      position: relative;
      z-index: 3;/*z-indexの数値をあげて文字を背景よりも手前に表示*/
    }

    button:hover span{
      color:#fff;
    }
    /*== 背景が流れる（中央から横全体） */
    button:before {
      content: '';
        /*絶対配置で位置を指定*/
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
        /*色や形状*/
      background: #333;
      width: 100%;
      height: 100%;
        /*アニメーション*/
      transition: transform .3s cubic-bezier(0.8, 0, 0.2, 1) 0s;
      transform: scale(0, 1);
      transform-origin: top;
    }

    /*hoverした際の形状*/
    button:hover:before{
      transform:scale(1, 1);
    }


    button {
      width: 260px;
      height: 60px;
      margin-top: 20px;
      cursor: pointer;
      font-size: 1.5em;
      background-color: #fff;
      color: #555555;
      border-radius: 10px;
    }

  `;

  } else {
    levelSelectArea = css`
      display: ${fase === 0 ? "block" : "none"};
      font-size: .8em;
      text-align: center;

    h4 {
      margin-top: 0;
    }
    padding: 0;
    margin: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    h3 {
      font-size: 1.7em;
      color: #555555;
    }
    rt {
      text-align: center;
    }
  `;
    myPageStyle = css`
    height: auto;
  `;
    message = css`
    display: ${fase === 0 ? "block" : "none"};
    text-align: center;
  `;

    levelList = css`
    margin: 0 auto 0 auto;
    /* width: 30vw; */
    padding: 0;
    /*== ボタン共通設定 */
    button{
        /*アニメーションの起点とするためrelativeを指定*/
        position: relative;
        overflow: hidden;
        /*ボタンの形状*/
        text-decoration: none;
        display: inline-block;
        border: 2px solid #555;/* ボーダーの色と太さ */
        padding: 10px 30px;
        text-align: center;
        outline: none;
        /*アニメーションの指定*/
        transition: ease .2s;
    }

    /*ボタン内spanの形状*/
    button span {
      position: relative;
      z-index: 3;/*z-indexの数値をあげて文字を背景よりも手前に表示*/
      color:#555555;
    }

    button:hover span{
      color:#fff;
    }
    /*== 背景が流れる（中央から横全体） */
    button:before {
      content: '';
        /*絶対配置で位置を指定*/
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
        /*色や形状*/
      background: #333;
      width: 100%;
      height: 100%;
        /*アニメーション*/
      transition: transform .3s cubic-bezier(0.8, 0, 0.2, 1) 0s;
      transform: scale(0, 1);
      transform-origin: top;
    }

    /*hoverした際の形状*/
    button:hover:before{
      transform:scale(1, 1);
    }


    button {
      width: 200px;
      height: 60px;
      margin-top: 10px;
      cursor: pointer;
      font-size: 1.5em;
      background-color: #fff;
      color: #555555;
      border-radius: 10px;
    }

  `;

  }


  const selectAreaWrap = css`
    display: flex;
  `;
  const myPageStyleWrap = css`
    display: flex;
  `;


  useEffect(() => {
    if (gameStatusValue != -1) {
      window.alert("アクセスできません。");
      window.location.assign("/");
    }
  }, [gameStatusValue]);


  return (
    <>
      <div css={teacherPageStyle}>
        {
          // id 認証
          idCertification ? (
            <div css={myPageStyle}>

              <div css={message}>
                <h4>ID: {teacherId} にログイン中です</h4>
              </div>
              <div css={myPageStyleWrap}>
                <div css={levelSelectArea}>
                  <br /><br /><br />
                  <div css={selectAreaWrap}>

                    <ul css={levelList}>
                      <h4><ruby>難易度<rt>なんいど</rt></ruby>を<ruby>選択<rt>せんたく</rt></ruby>してください</h4>
                      {
                        level === "easy" ? (
                          <>
                            <button style={{ backgroundColor: '#555555', color: '#ffffff', cursor: 'pointer' }} onClick={() => {
                              setLevel("easy");
                            }}
                            ><span>easy</span></button><br />
                          </>
                        ) : (
                          <>
                            <button onClick={() => {
                              setLevel("easy");
                            }}><span>easy</span></button><br />
                          </>
                        )
                      }
                      {
                        level === "normal" ? (
                          <>
                            <button style={{ backgroundColor: '#555555', color: '#ffffff', cursor: 'pointer' }} onClick={() => {
                              setLevel("normal");
                            }}><span>normal</span></button><br />
                          </>
                        ) : (
                          <>
                            <button onClick={() => {
                              setLevel("normal");
                            }}><span>normal</span></button><br />
                          </>
                        )
                      }

                      {
                        level === "hard" ? (
                          <>
                            <button style={{ backgroundColor: '#555555', color: '#ffffff', cursor: 'pointer' }} onClick={() => {
                              setLevel("hard");
                            }}><span>hard</span></button><br />
                          </>
                        ) : (
                          <>
                            <button onClick={() => {
                              setLevel("hard");
                            }}><span>hard</span></button><br />
                          </>
                        )
                      }
                    </ul>
                  </div>
                </div>
                <div>
                  <ItemSelectArea fase={fase} />
                </div>
                <button className="fase-change" onClick={() => {
                  if (fase === 0) {
                    if (!level) {
                      window.alert("レベルを選択してください");
                      return;
                    }
                    setFase(1);

                  }
                  else {
                    setFase(0);
                    setLevel("");
                  }
                }}>
                  {fase === 0 ? "アイテム選択へ" : "レベル選択へ"}
                </button>
                <Link to={`/teacher/${level}`} ><button className='start-btn' onClick={() => {
                  setFase(0);
                  if (gameStatusValue === -1) setGameStatusValue(1);
                  window.removeEventListener("beforeunload", function (event) {
                    event.preventDefault();
                  });

                }}>Start</button></Link>
              </div>
            </div>
          ) :
            (
              <div className='window'>
                <h3>ID認証</h3>
                <p>先生のIDを入力してください</p>
                {
                  unSuccessful ? (
                    <>
                      <TextField
                        error
                        id="outlined-error-helper-text"
                        label="Error"
                        helperText="Incorrect entry."
                        sx={{ marginTop: `${isPC ? "250px" : "18vh"}` }}
                        onChange={(e) => {
                          if (e.target.value.length === 4) {
                            inputPass(e.target);
                          }
                        }}
                        onKeyDown={(e) => {
                          if (e.key = 'Enter') {
                            inputPass(e.target)
                          }
                        }}
                      />
                    </>
                  ) : (
                    <>
                      <TextField
                        id="filled-basic" label="ID" variant="filled"
                        sx={{ marginTop: `${isPC ? "250px" : "18vh"}` }}
                        onChange={(e) => {
                          if (e.target.value.length === 4) {
                            inputPass(e.target);
                          }
                        }}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            // エンターキー押下時の処理
                            inputPass(e.target);
                          }
                        }}
                      />

                    </>

                  )
                }

              </div>
            )
        }
      </div >

    </>
  );

}


export default TeacherMyPage
